import React, { useState } from 'react';
import styles from './VideoScreen.module.css';
import betty from "../videos/בטי קנפו סרטון מסך ראשי (1).mp4"
import logo from "../images/בטי קנפו לוגו.png"
import Loader from '../components/loader/Loader';

const HomePage = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const handleVideoLoaded = () => {
    setIsVideoLoaded(true);
  };

  return (
    <div className={styles.container}>
      {/* Loader Overlay */}
      {!isVideoLoaded && <Loader />}
      
      {/* Header Section */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.title}>Betty Knafo</div>
          
          {/* Scrolling Text Marquee */}
          <div className={styles.marqueeContainer}>
            <div className={styles.marquee}>
              <span className={styles.marqueeText}>
                מכון יופי וטיפוח | הכל במקום אחד | תכשיטי בוטיק | הדבקת ריסים | איפור כלות וערב | שיזוף בהתזה | עיצוב גבות | 
              </span>
              <span className={styles.marqueeText}>
                מכון יופי וטיפוח | הכל במקום אחד | תכשיטי בוטיק | הדבקת ריסים | איפור כלות וערב | שיזוף בהתזה | עיצוב גבות | 
              </span>
                  <span className={styles.marqueeText}>
                מכון יופי וטיפוח | הכל במקום אחד | תכשיטי בוטיק | הדבקת ריסים | איפור כלות וערב | שיזוף בהתזה | עיצוב גבות | 
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* Video Section */}
      <div className={styles.videoSection}>
        <video
          className={styles.video}
          autoPlay
          loop
          muted
          playsInline
          onCanPlayThrough={handleVideoLoaded}
        >
          <source src={betty} type="video/mp4" />
          הדפדפן שלך לא תומך בתגית וידאו.
        </video>
      </div>
    </div>
  );
};

export default HomePage;